<template>
  <v-card
    class="px-4"
  >
    <v-card-actions>
      <v-card-title class="font-weight-bold my-2" style="font-size:26px;">{{ $t('Lid') }}の追加</v-card-title>
      <v-spacer></v-spacer>
      <v-icon x-large @click="$emit('close')">mdi-close</v-icon>
    </v-card-actions>    
    <!--Lid名-->
    <v-card-actions>
      <v-row>
        <div>
          <v-img max-height="100" max-width="10" src="../assets/png/rectangle.png"></v-img>
        </div>
        <v-col class="pt-0 pb-0">
          <v-text-field 
            color="#008CFF" 
            clearable
            label="Lid名"
            hide-details
            v-model="lidName"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-actions>
    <!--Lidメンバー-->
    <v-card-actions style="font-size:18px; color:#707070" class="mt-2 pt-0 pl-2">
      <p class="mb-0">{{ $t('Lid') }}のメンバー</p>
      <v-btn
        color="#707070" dark small
        data-testid="addLid_LidMemeberEdit"
        class="rounded-xl ml-4"
        @click="addlidMember = true"
      >
        <v-icon color="white" x-small>mdi-cog</v-icon>
        編集
      </v-btn>
    </v-card-actions>
    <v-card-text class="pl-2 pb-0"><span class="font-weight-bold text-h4" style="color:#2B2B2B" v-if="candiMem" v-text="candiMem.length"></span>人</v-card-text>
    <!--Lid管理者-->
    <v-card-actions style="font-size:18px; color:#707070" class="mt-2 py-0 pl-2">
      <p class="mb-0">{{ $t('Lid') }}の管理者</p>
      <v-btn
        color="#707070" dark small
        data-testid="addLid_LidAdminEdit"
        class="rounded-xl ml-4"
        @click="addlidAdmin = true"
      >
        <v-icon color="white" x-small>mdi-cog</v-icon>
        編集
      </v-btn> 
    </v-card-actions>
    <v-card-actions class="align-center">
      <v-btn
        elevation="0"
        @click="profileUid = candiAdm[0],profile = true"
        class="px-2"
        v-if="candiAdm&&candiAdm[0]"
      >
        <v-avatar size="25" v-if=profImageDict[candiAdm[0]]>
          <img :src="profImageDict[candiAdm[0]]">
        </v-avatar>
        <span class="font-weight-light" v-text="namelist[candiAdm[0]]"></span>
      </v-btn>
      <p class="mb-0" v-if="candiAdm.length>1">ほか<span v-if="candiAdm.length>1" v-text="candiAdmNum"></span>人</p>
    </v-card-actions>
    <!--Lid公開設定-->       
    <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
      {{ $t('Lid') }}の公開設定
    </v-card-text>
    <v-card-actions class="pl-2 py-0">
      <v-radio-group
        v-model="row"
        row
      >
      <v-radio
        label="公開"
        value="public"
      ></v-radio>
      <v-radio
        v-if="authConfig.officer"
        label="庁内運用Lid"
        value="privateAndOpenedForGov"
      ></v-radio>
      <v-radio
        label="非公開"
        value="private"
      ></v-radio>
      </v-radio-group>
    </v-card-actions>
    <!--Lidアイデアテーマ-->
    <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
      {{$t('アイデア')}}出しのテーマ<span style="font-size:14px;">(20字以内)</span>
    </v-card-text>        
    <v-card-actions class="pl-2">
      <v-text-field
        clearable
        placeholder="未入力"
        color="#DCDCDC"
        v-model="ideaTheme"
      ></v-text-field>
    </v-card-actions>
    <!--Lidアイデアプレースホルダー-->
    <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
      {{$t('アイデア')}}のプレースホルダー<span style="font-size:14px;">(20字以内)</span>
    </v-card-text>        
    <v-card-actions class="pl-2">
      <v-text-field
        clearable
        placeholder="未入力"
        color="#DCDCDC"
        v-model="ideaHolder"
      ></v-text-field>
    </v-card-actions>
    <!--Lidタグ-->
    <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0 mt-4">
      {{$t('アイデア')}}のタグ設定
    </v-card-text>
    <v-card-actions class="pl-2 py-0">
      <v-radio-group
        v-model="setTag"
        row
      >
      <v-radio
        label="設定する"
        :value="true"
      ></v-radio>
      <v-radio
        label="設定しない"
        :value="false"
      ></v-radio>
      </v-radio-group>
    </v-card-actions>
    <v-card-actions v-if="setTag===true" class="d-flex flex-column">
      <div class="d-flex align-center mx-4" style="width:100%;" v-for="n in tagNum" :key="n">
        <p class="mb-0 mx-2">タグ{{ n }}</p>
        <v-menu
          v-model="selectColor"
          :close-on-content-click="true"
          :nudge-width="180"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" tile depressed class="px-0" @click="k=n">
              <v-icon :color="tagColors[n-1]">mdi-circle</v-icon>
            </v-btn>
          </template>
          <v-card v-if="n==k">
            <v-card-text class="pa-2 pb-0">タグの色(色をクリックして選択)</v-card-text>
            <v-card-actions>
              <v-btn @click="tagColors[n-1] = '#2B2B2B'" icon><v-icon color="#2B2B2B" size="50">mdi-circle</v-icon></v-btn> 
              <v-btn @click="tagColors[n-1] = '#294A66'" icon><v-icon color="#294A66" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#008CFF'" icon><v-icon color="#008CFF" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#399942'" icon><v-icon color="#399942" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#54E363'" icon><v-icon color="#54E363" size="50">mdi-circle</v-icon></v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn @click="tagColors[n-1] = '#DCDCDC'" icon><v-icon color="#DCDCDC" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#BA0009'" icon><v-icon color="#BA0009" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#FF8796'" icon><v-icon color="#FF8796" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#E05922'" icon><v-icon color="#E05922" size="50">mdi-circle</v-icon></v-btn>
              <v-btn @click="tagColors[n-1] = '#FFB336'" icon><v-icon color="#FFB336" size="50">mdi-circle</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-text-field placeholder="タグに設定する文字を入力(10文字)" color="#DCDCDC" v-model="tagNames[n-1]" class="mx-2 pr-4"></v-text-field>
        <v-btn icon @click="tagNum--,tagNames.splice(n-1,1),tagColors.splice(n-1,1)" v-if="tagNum>1&&n!=1"><v-icon color="#E64550">mdi-close</v-icon></v-btn>
      </div>
      <p v-if="isEmpty" class="mb-0 mx-2 deepLava--text">タイトルが空白のタグがあります</p>
      <p v-if="!isUnDup" class="mb-0 mx-2 deepLava--text">タイトルが重複しているタグがあります</p>
    </v-card-actions>
    <v-card-actions v-if="setTag===true">
      <v-checkbox
        v-if="tagNum>1||tagNames[0]"
        :label="$t('アイデア')+'投稿時のタグを必須にする'"
        class="pl-4 mt-0" hide-details
        v-model="tagRequired"
      ></v-checkbox>
      <v-spacer></v-spacer>
      <v-btn @click="tagNum++,tagNames[tagNum-1]='',tagColors[tagNum-1]=tagColors0[tagNum-1]" v-if="tagNum<10" :disabled="tagNames[tagNum-1]==''">+設定するタグを追加</v-btn>
    </v-card-actions>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="addbtn white--text px-8" color="#008CFF" rounded elevation="0" @click="submitLid()" :disabled="!isSubmitLid">
        追加
      </v-btn>
    </v-card-actions>

    <!--Lid追加時のメンバー画面-->
    <v-dialog
      v-model="addlidMember"
      width="800"
      @keydown.esc="addlidMember = false"
      persistent
    >
      <listMem mode="addLid" @listMemClose="closeAddlidMember" @lidCandiMems="onelidCandiMembers"></listMem>
    </v-dialog>
    <!--Lid追加時の管理者画面-->
    <v-dialog
      v-model="addlidAdmin"
      width="800"
      @keydown.esc="addlidAdmin = false"
      persistent
    >
      <listAdm mode="addLid" @listAdmClose="closeAddlidAdmin" @lidCandiAdms="onelidCandiAdmins"></listAdm>
    </v-dialog>
    <!--プロフィール画面-->
    <profile_display
      :profile="profile"
      :profuid="profileUid"
      device="pc"
      @closeProfile="profile=false"
    ></profile_display>
  </v-card>
</template>

<script>
import firebase from 'firebase'
import listAdm from './listAdm.vue'
import listMem from './listMem.vue'
const profile_display = () => import('../components/profile/profile_display.vue')
export default {
    components:{
      listAdm,
      listMem,
      profile_display
    },
    props:{
      members: Array,
      namelist: Object,
      config: Object,
      ws: Object || null,
    },
    data: () => ({
      db: null,
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      lidName: "",
      row: 'public',
      ideaTheme: "",
      ideaHolder: "",
      ideaDesc: "",
      addlidMember: false,
      addlidAdmin: false,
      candiMem: [],
      candiAdm: [],
      postIdeaOnContent: false,
      postIdeaAnonymous: true,
      isOpenIdeaThread: false,
      selectColor: false,
      setTag:false,
      tagNames: [], //登録するタグ名リスト
      tagNum: 1,
      tagRequired: false,
      k:0,
      //登録するタグリスト
      tagColors:[
        "#2B2B2B",
        "#294A66",
        "#008CFF",
        "#399942",
        "#54E363",
        "#DCDCDC",
        "#BA0009",
        "#FF8796",
        "#E05922",
        "#FFB336"
      ],
      //タグ色のオリジナル
      tagColors0:[
        "#2B2B2B",
        "#294A66",
        "#008CFF",
        "#399942",
        "#54E363",
        "#DCDCDC",
        "#BA0009",
        "#FF8796",
        "#E05922",
        "#FFB336"
      ],
      profile: false,
      profileUid: ""
    }),
    computed:{
      isEmpty(){
        //タグのタイトルに空白があるか
        let isEmpty = false
        const setElements = new Set(this.tagNames)
        isEmpty = setElements.has("")
        return isEmpty
      },
      isUnDup(){
        //タグのタイトルが重複していないか
        let isUnDup = false
        const setElements = new Set(this.tagNames)
        isUnDup = setElements.size === this.tagNames.length
        //console.log("isUnDup:",isUnDup,setElements,this.tagNames,setElements.size,this.tagNames.length)
        return isUnDup
      },
      isSubmitLid(){
        let isTag = false
        if(this.setTag){
          //console.log(this.isUnDup,this.isEmpty)
          if(
            this.tagNames[0] != "" && this.tagNames[0] != undefined && this.tagNames[0] != null &&
            this.tagNames[this.tagNum-1] != "" && this.tagNames[this.tagNum-1] != undefined && this.tagNames[this.tagNum-1] != null &&
            this.isUnDup &&
            !this.isEmpty
          ) isTag = true
        }
        else isTag = true
        return this.lidName != "" && this.lidName != undefined && this.lidName != null && isTag
      },
      isAdmin(){
        return this.$store.state.isAdmin
      },
      candiAdmNum(){
        return this.candiAdm.length - 1
      },
      idea_thread(){
        if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_thread) return this.$store.state.config.setting.idea_thread
        else return false
      },
      profImageDict(){
        return this.$store.state.profImageDict
      },
    },
    created(){
      this.db = firebase.firestore()
      if(firebase.auth().currentUser!=null) this.uid = firebase.auth().currentUser.uid
      this.candiMem[0] = {uid:this.uid}
      this.candiAdm[0] = this.uid
    },
    methods: {
      //lid追加
      async submitLid() {
        this.today()
        let self = this
        await this.db.collection("0").add({
          title: this.lidName,
          sort: this.todayy,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          config:false,
          isActive:true,
          isOpen:this.row == 'privateAndOpenedForGov' ? 'private' : this.row,//公開かどうか
          isOpenForGovStaff: !!(this.authConfig.officer && this.row == 'privateAndOpenedForGov'),
          settings: {
            postIdeaOnContent: self.postIdeaOnContent,
            postIdeaAnonymous: self.postIdeaAnonymous,
            isOpenIdeaThread: self.isOpenIdeaThread,
          },
          lidAdmin: this.candiAdm,//要検討
          ideaTheme:this.ideaTheme,
          ideaHolder:this.ideaHolder,
          ideaDesc:this.ideaDesc,
          counter:{
            member: this.candiMem.length,
            idea: 0,
            project: 0,
            activeUser: 0
          },
          tags:{
            title: self.tagNames.filter((c)=>c.length).length ? [...new Set(self.tagNames.filter((c)=>c.length))] : [].filter((c)=>c.length).length ? self.tagNames : [],
            color: self.tagColors,
            required: (self.tagNames.filter((c)=>c.length).length && self.tagNames.filter((c)=>c.length).length) ? self.tagRequired : false
          },
          isWs: this.ws ? true : false,
          wsTitle: this.ws?.title || "",
          wsId: this.ws?.id || "",
        }).then(function(docRef) {
          // 保存に成功した時
          console.log("Document written with ID: ", docRef);
          if(self.ws?.id){
            console.log("thenwss", self.ws, docRef.id)
            self.db
            .collection("0")
            .doc("config")
            .collection("ws")
            .doc(self.ws.id)
            .update({
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
              lids: firebase.firestore.FieldValue.arrayUnion(docRef.id)
            }).then(()=>{
              self.$store.dispatch('getwss')
            })
          }
          self.postIdeaOnContent = 'false'
          self.postIdeaAnonymous = 'true'
          self.isOpenIdeaThread = 'false'
          if (self.row == "public") {
            self.$store.dispatch('setConfigNotify',({
              title:`新規${self.$t('Lid')}開始`,content:`新しい${self.$t('Lid')}:${self.lidName}が開始されました`,address:"all",type:3,lidid:docRef.id,tag:"Lid",
              useLine: !!JSON.parse(process.env.VUE_APP_NOTIFY_CONFIG||"{}").addLid
            }))
          }
          self.$store.dispatch('setLidNotify',({
            title:`新規${self.$t('Lid')}開始`,content:`新しい${self.$t('Lid')}:${self.lidName}が開始されました`,address:"all",type:3,lidid:docRef.id,tag:"Lid"}))
          self.$store.dispatch('getLid')
          self.$emit('close')
          self.submitLiduser(docRef.id)
        }).catch(function(error) {
        // 保存に失敗した時
          self.postIdeaOnContent = false
          self.postIdeaAnonymous = true
          self.isOpenIdeaThread = false
          console.error("Error adding document: ", error);
        })
        //await window.location.reload()
      },
      submitLiduser(id){
        let self = this,i = 0
        //console.log(this.candiMem)
        this.candiMem.forEach((el) => {
          i++
          this.db.collection("0").doc(id).collection("liduser").doc(el.uid).set({
            uid: el.uid,
            isActive: true,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
          }).then(function(docRef) {
            self.$emit('close')
            // 保存に成功した時
            //console.log("USERss Document written with ID: ", docRef.id)
            console.log("Lidユーザ登録完了")
          }).catch(function(error) {
          // 保存に失敗した時
            console.log("Lidユーザ登録失敗")
          })
        })
      },
      onelidCandiMembers(el){
        this.candiMem = el
      },
      onelidCandiAdmins(el){
        this.candiAdm = el
      },
      closeAddlidMember(el){
        this.addlidMember = el
      },
      closeAddlidAdmin(el){
        this.addlidAdmin = el
      },
      today(){
        // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = this.toDoubleDigits(date.getMonth() + 1)
        let dd = this.toDoubleDigits(date.getDate())
        let hh = this.toDoubleDigits(date.getHours())
        let mi = this.toDoubleDigits(date.getMinutes())
        let se = this.toDoubleDigits(date.getSeconds())
        let ms = this.toDoubleDigits(date.getMilliseconds())
        this.todayy = yyyy + mm + dd + hh + mi + se + ms
      },
      toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
            num = "0" + num;
        }
        return num
      },
    }
}
</script>